import { instance } from '@/libs/api/instance.js'

/**
 * Change wallet flag - favourite
 *
 * @param {string} walletUuid
 * @param {integer} flagValue
 * @param {integer} validate
 * @return {Promise<axios.AxiosResponse<any>>}
 */
const favourite = (walletUuid, flagValue, validate = 0) => {
  return instance.put(
    `/v3/wallet/${walletUuid}/favourite`,
    {
      flag: Number(flagValue),
    },
    {
      params: {
        validate: Number(validate),
      },
    },
  )
}

export default {
  favourite,
}
